//en.js

import enLocale from 'element-ui/lib/locale/lang/en'
const en = {
  message: {
    'veS_overall_s_pl': 'please enter the keyword',
  },
  page: {
    show_list: 'Show',
    hide_list: 'Hide',
    choose_languages: 'Languages',
    chinese_languages: '中文',
    english_languages: 'English',
    please_enter_tracking_limit: 'Enter up to 40 tracking numbers, one per line.',
    delete_all: 'Delete All',
    select_no: 'Select Tracking No.',
    delete_carrier: 'Delete',
    carrier: 'Carrier',
    track: 'Track',
    one_line_enter_limit: 'Enter up to 40 tracking numbers, one per line.',
    more_than_limit_number_tip: 'Tips ：maximum support of query 40 tracking No. at a time',
    please_enter_tracking_no: 'Input Tracking No.',
    more_than_limit_number_tip2: 'Warming ：maximum support of query 40 tracking No. at a time',
    some_tracking_no_wrong: 'Some tracking No. may be  wrong (Marked red ) ',
    quick_track: 'Quick inquiry',
    choose_carrier: 'Select',
    not_find_carrier: 'Can not found the Carrier',
    common_carrier: 'Common Carrier',
    global_postal_service: 'Global Postal Service',
    international_carrier: 'International Carrier',
    chinese_carrier: 'Chinese Carrier',
    return: 'Return',
    has_found_carrier: 'Has found the ture Carrier',
    please_input_carrier: 'Input Carrier',
    global_logistics_tracking_platform: 'Global Shipment Tracking Platform',
    tracking_more: 'Tracking More',
    not_find_data: 'No found.',
    tracking_no: 'Tracking No.',
    please_track__latter: 'Please Track latter.',
    being_in_query: 'Being in query……',
    failed_query: 'Failed query.',
    cannot_found_carrier_please_choose_carrier: 'Can not found the Carrier , Please match the Carrier by hand.',
    maybe_these_carrier: 'Can not found the ture Carrier , Please match the Carrier by hand.',
    not_find_tracking: 'No found.',
    newest_data_tracked: 'The newest data you tracked',
    check_failure: 'Check the Failure',
    not_found_temporaily: 'No found temporarily',
    copy_tracking_content: 'Copy tracking content',
    copy_tracking_url: 'Copy the tracking URL',
    success_copy_tracking_content:　'Successfully copied the tracking content',
    success_copy_tracking_url: 'Successfully copied the tracking URL',
    All: 'All',
    Pending: 'Pending',
    Not_Found: 'Not Found',
    Info_Received: 'Info Received',
    In_Transit: 'In Transit',
    Pick_Up: 'Out For Delivery',
    Delivering: 'Delivering',
    Undelivered: 'Failed Attempt',
    Delivered: 'Delivered',
    Return: 'Return',
    Exception: 'Exception',
    welcome_to_tracking_yee: 'Welcome to TrackingYee',
    in_query: 'In query',
    query_failed: 'Failed query',
    query_successful: 'Successful Query',
    not_supported_query: 'This carrier  does not supported query for the time being',
    not_provide_logistics: 'The carrier  does not provide logistics trajectory for the time being',
    please_choose_carrier: 'Please Choose Carrier',
    please_no_get_track: 'Track Your Shipment',
    login: 'Login',
    signup: 'Sign Up',
    Cross_border:'Cooperative transporter',
    each_package: 'Easily track real-time updates on each package',
    worldwide:'Support for more than 200 courier companies worldwide',
    see_more:'See More',
    monitoring_management:'A tailor-made logistics monitoring management system for the seller to easily track the real-time dynamics of each package',
    Click_fast:'Click fast',
    or:'or',
    Accounts:'Accounts',
    Use_it_now:'Use it now!',
    Copyright:'Copyright ICP Certificate:',
    about_Tracking_Yee:'About Tracking Yee',
    home_page:'Home',
    Transporter_list:'Transporter list',
    Help_sellers:'Help sellers choose a transportation channel that is more suitable for them',
    Support_query:'Support query',
    dont_Support_query:'Does not support queries',
    all:'all',
    Please_enter:'Please enter the content',
    search: 'Search',
    vesaas:'Tracking Yee',
    The_operation:'The operation is simple, the data status is clear at a glance, saving time and worry!',
    for_free:'Want to get such a detailed report for free,',
    Highlight:'Highlight function introduction',
    Track_logistics:'Track logistics status in real time, easily manage order logistics information, automatically generate reports to assist in analyzing logistics timeliness',
    major:'3 major functions of the trajectory tracking tool',
    Waybill:'Waybill track query',
    When_you_query_once:'When you query once, the system can track N times, until the package is properly voted to complete the trajectory tracking;',
    Support_to_set_platform:'Support to set platform billing aging rules',
    Supports_rule_setting:'Supports rule-setting for delivery speed corresponding to the platform standard. The system allows you to set the delivery speed according to different platform standards by yourself. For example, if you upload a waybill number on platform, the logistics trajectory needs to be displayed within 7 days. Then, the system will automatically monitor the order you inquired. When the package status is uploaded after 7days of its delivery, you can see the abnormal package information by entering the system.',
    Support_setting:'Support setting logistics service provider commitment time limit rules',
    delivery_efficiency:'Supports rules-setting for delivery efficiency committed by logistics service providers. When you want to evaluate the performance of your logistic service providers, you can just set the delivery speed committed by specific logistics services (The information about logistics service can be specified corresponding to different transportation providers). The system can automatically track the real –time status of a package and compare it with the speed standard that you have set, which provides a reference for you to optimize your logistic management.',
    Meamwhile:'Meamwhile, in terms of the order status tracking function, ',
    have_multiple:'Trackingyee have multiple methods for users to inquiry in different scenarios.',
    You_can_inquiry:' You can inquiry by directly inputting the order number in the box. Normally, the amount of order number should be within  40 pcs in each inquiry.',
    Import_query:'Import query',
    Import_order_number:'Import order number for inquiry. When you have a large number of orders, you can use EXCEL table to import order information in bulk for inquiry. The system only supports parcel status tracking by using order number.',
    Store_authorization:'Store authorization',
    make_a_store_authorization:'When you make a store authorization, there’s no need to import information manually every day. The system will automatically capture the orders that will be queried by the store owner. What you only need to do is to inquiry periodically and download the status tracking results.',

    // functionalAdvantages
    functionalAdvantages_oneStopStr:'TrackingYee,One-stop order inquiry and monitoring, logistics report management system. It can support users to track the logistics track of orders, monitor the timeliness of waybills according to the rules required by users, and support comparing the timeliness promised by logistics service providers. Logistics data at a glance, select quality suppliers; Respond to and handle abnormal waybills effectively, solve 80% of your after-sales problems, and make your business healthier. Intelligent monitoring waybill, multi-dimensional timeliness analysis, your trustworthy logistics butler!',
    functionalAdvantages_track:'Track the track of the parcel waybill',
    functionalAdvantages_once:'Once the query, the system can automatically enter and regularly track the update status',
    functionalAdvantages_various:'Various ways of waybill import: simple operation, clear data status',
    functionalAdvantages_toQuery:'Track',
    functionalAdvantages_intelligent:'Intelligent aging monitoring and warning',
    functionalAdvantages_supportPlatform:'Support the custom setting of different platform logistics evaluation prescription rules and monitoring',
    functionalAdvantages_supportCommitment:'Support custom logistics commitment time assessment',
    functionalAdvantages_orderWarning:'Order abnormal status warning',
    functionalAdvantages_immediately:'Click to Start ',
    functionalAdvantages_systemAccording:'The system can form reports according to the distribution of different platforms, stores, logistics providers, countries and regions',
    functionalAdvantages_distribution:'Display distribution charts of parcel waybills on different delivery dates',
    functionalAdvantages_presentation:'Multi-dimensional report data presentation',

    functionalAdvantages_morePersonalized:'More personalized features are waiting for you to solve 80% of your after-sales problems and make your business healthier.',
    functionalAdvantages_experience:'What are you hesitating about? Start your new experience now!',
    functionalAdvantages_tryNow:'Try Now',
    functionalAdvantages_waybillQuery:'Tracking',
    functionalAdvantages_waybillQuery1:'Track your shipment',
    functionalAdvantages_functionalAdvantages:'Features',
    functionalAdvantages_externalCall:'External Call',
    // home
    home_a:'Automated Shipment Status Tracking',
    home_aaaa:'and In-depth Statistics Analysis',
    home_b:'Boost your business with TrackingYee!',
    home_c:'Track Your Shipment',
    home_d:'Enter Tracking Number(s). Separate with a comma (,).',
    home_e:'Carrier',
    home_f:'TrackingYee is a SaaS-based order tracking and shipping management system designed to meet the diverse needs of the cross-border e-Commerce industry. As one-stop solutions platform, TrackingYee offers a convenient gateway to track and trace all your orders automatically from pickup to delivery; And also, by analyzing the shipment results — like custom delivery performance analysis by carrier/platform/store, it provides you accurate statistics and many in-depth reports so that you can get a better overview of your shipping performance; With its individualized delivery notifications/alert, it also allows you to take proactive approach to customer complaints and handle up to 80% after-sales problems. ',
    home_g:'',
    home_ggg:'TrackingYee is your smart choice to simplify daily tracking tasks with automation tools available to you. With its capabilities in data-based analysis and custom setting, it helps you make faster, better-informed business decisions, optimize performance and boost your sales internationally!',
    home_h:'All-in-One Platform',
    home_i:'Track and control all aspects of the shipment process on a single platform with massive statistics and analysis',
    home_j:'User-friendly Portal',
    home_k:'With the simple and user-friendly interface, you can easily learn and master all the functions.',
    home_l:'One-to-One Guidance',
    home_m:'Our professional service team to quickly respond to every customer’ special requests and needs.',
    home_n:'Explore Our Features',
    home_o:'',
    home_p:'',
    home_q:'Online Stores Authorization Management',
    home_r:'Multi-methods Data Import&Export',
    home_s:'Customized Shipping Data Analysis',
    home_t:'Overall Shipment Quality Control',
    home_u:'Setting Delivery Time Adhere to Marketplaces',
    home_v:'Enter The System',
    home_w:'See More',
    home_x:'Find All Our Services',
    home_y:'',
    home_z:'',
    home_aa:'Join Our Partner Network',
    home_bb:'Merchant Partners',
    home_cc:'Simplify daily tasks with automated tracking tool;',
    home_dd:'Personalize shipping methods to match marketplace requirements;',
    home_dd1:'No more trouble with after-sale problems and exception cases;',
    home_ee:'E-commerce Partners',
    home_ff:'Timely order shipment status tracking with high quality service;',
    home_gg:'Effective analysis for quality monitoring control;',
    home_hh:'Optimize shipping performance, improve customer satisfaction;',
    home_ii:'',
    home_kk:'Payment Service Partners',
    home_ll:'Nearly real-time tracking information with high quality services;',
    home_mm:'Automate customized tasks and monitor key tracking events;',
    home_mm1:'Control whole payment process and reduce the risk of fraud;',
    home_nn:'Logistics Service Partners',
    home_oo:'Timely order shipment status tracking with high quality service;',
    home_pp:'Enhance overall logistics performance with in-depth statistics analysis;',
    home_pp1:'Improve efficiency of supplier management, reduce operating costs;',
    home_qq:'Automated Shipment Status Tracking and In-depth Statistics Analysis',
    home_rr:'Boost your business with TrackingYee!',
    home_ss:'Support 350+ Major Shipping Carriers Worldwide',
    home_tt:'',
    home_uu:'Automated Tracking Tool',
    home_vv:'All-in-One tracking platform allow you to easily search, filter and process all your order status and delivery information ',
    home_ww:'Timely Exceptions Handling and Notifications',
    home_xx:'Automate order tracking and send notifications to help you improve customers’ shopping experience',
    home_yy:'In-depth Shipment Statistics Analysis',
    home_zz:'All your shipment results will be well-calculated to generate effective reports cater to your preferences or shipment requirements',
    home_aaa:'Support Major Shipping Carriers and More',
    home_bbb:'Over 350 shipping carriers world-wide, and we are able to support tracking for many more carriers constantly…',
    home_ccc:'View More',
    home_ddd:'About',
    home_eee:'Fold',//


    // pagefooter
    pagefooter_a:'TrackingYee is your smart choice to simplify daily tracking tasks with automation tools. With its capabilities in data-based analysis and custom setting, it helps you make faster, better-informed business decisions, optimize performance and boost your sales internationally!',
    pagefooter_b:'Tel',
    pagefooter_c:'Email',
    pagefooter_d:'Address: Room 308-310, Building C, Xanadu Creative Park, Nanshan District, Shenzhen',
    pagefooter_e:'Share it on WeChat',
    pagefooter_f:'Open up WeChat, click on find at the bottom,',
    pagefooter_g:'Use "scan" to share your web page to your moments.',
    pagefooter_h:'Please enter the carrier',
    pagefooter_i:'Top',

    // logisticsList
    logisticsList_a:'Support to query over',
    logisticsList_b:'carriers worldwide',
    logisticsList_c:'Help the seller to choose a more suitable transport channel',

    components_a:'Track',

    trajectoryTracking_head_title:'External call',
    trajectoryTracking_head_title1:'By integrating the logistics tracking component and embedding it into your website, website visitors can directly query the tracking details of the waybill on your web page',
    trajectoryTracking_single_model:'Single query mode',
    trajectoryTracking_singleLink_model:'Specify tracking number query mode',
    trajectoryTracking_batch_model:'Batch query mode',
    trajectoryTracking_model_introduction:'Mode introduction',
    trajectoryTracking_model_introduction_a:'You can add a single-line input box and query button. After the website visitor enters the tracking number, the query result will be displayed according to your configuration when clicking the query.',
    trajectoryTracking_model_introduction_b:'It is to nest the input box that supports multiple tracking numbers on your website. When you click it, it will jump directly to TrackingYee to display the query result.',
    trajectoryTracking_model_introduction_c:'You can also attach a click event designated order number to the specific button, hyperlink text, icon, and other elements, so that the click can display the query result.',
    trajectoryTracking_Example_effect:'Example effect',
    trajectoryTracking_Example:'Example',
    trajectoryTracking_number_tips:'Please enter the waybill number and get the tracking result',
    trajectoryTracking_btn:'Start query',


    trajectoryTracking_Parameter:'Parameter formulation',
    trajectoryTracking_Parameter_id:'Specify the container ID that carries the content',
    trajectoryTracking_Parameter_w:'Query result width',
    trajectoryTracking_Parameter_h:'Query result height',
    trajectoryTracking_Parameter_m:'Results display mode',
    trajectoryTracking_Parameter_s:'Transporters',
    trajectoryTracking_Parameter_n:'Inquiry number',

    trajectoryTracking_Parameter_dm:'Call code',
    trajectoryTracking_Parameter_body1:'Add the following javascript on your page once, preferably in the open',
    trajectoryTracking_Parameter_body2:'After marking',
    trajectoryTracking_Parameter_copy:'Copy code',
    trajectoryTracking_Parameter_script1:'Copy and paste the code below into your page',
    trajectoryTracking_Parameter_script2:'Between tags',
    trajectoryTracking_Parameter_script3:'No matter what buttons you place, these buttons will show',
    trajectoryTracking_notes1:'Order number input box',
    trajectoryTracking_notes2:'Button for calling script method',
    trajectoryTracking_notes3:'Container for displaying query results',
    trajectoryTracking_notes4:'Script code can be placed at the bottom of the page and wait until the end of the page to be executed',
    trajectoryTracking_notes5:'Required, specify the container ID that carries the content',
    trajectoryTracking_notes5_:'Required, specify the element ID of the floating position',
    trajectoryTracking_notes6:'Optional, specify the query result width',
    trajectoryTracking_notes7:'Optional, specify the height of the query result',
    trajectoryTracking_notes8:'Result display mode, the default is to expand the nested area to display query results',
    trajectoryTracking_notes9:'Optional, specify the carrier, the default is automatic identification',
    trajectoryTracking_notes10:'Optional, specify UI language, default Chinese',
    trajectoryTracking_notes11:'Container for displaying query input box',
    trajectoryTracking_notes12:'The query result will be suspended in this element',
    trajectoryTracking_notes13:'Required, specify the tracking number to be queried',
    trajectoryTracking_min:'Minimum is',
    trajectoryTracking_default:'default is',

    trajectoryTracking_Parameter_IDplaceholder:'Please enter the ID of the container hosting the content',
    trajectoryTracking_Parameter_nesting:'Expand the nested area to display query results',
    trajectoryTracking_Parameter_suspension:'Floating box displays query results',
    trajectoryTracking_Parameter_sPlaceholder:'The carrier can be specified, and the default is automatically matched',
    trajectoryTracking_Parameter_Nplaceholder:'Please enter the tracking number',
  },
  productHome:{
    'product_home_font': 'home',
    'product_open_font': 'open',
    'product_open_concent': 'This operation will permanently delete the file. Do you want to continue ?',
    'product_open_title': 'Tips',
  },
  ...enLocale
}

export default en;



// WEBPACK FOOTER //
// ./src/i18n/langs/en.js